import Home from "../views/home";
import Service from "../views/services";
import ContactUs from '../views/contactUs';
import IndividualService from "../views/individualService";
import AboutUs from '../views/aboutUs';
import ProjectDetails from "../views/projectDetails";
import SMediaService from '../views/sMediaService';
import CaseStudy from "../components/CaseStudy";

import Blogs from "../components/Blogs/Blogs";
import BlogDetails from "../components/Blogs/BlogDetails";

const routes = [
    { components: <Home/>, to: '/' },
    { components: <CaseStudy />, to: '/casestudy' },
    { components: <ContactUs />, to: '/contactUs' },
    { components: <IndividualService />, to: '/individualService' },
    { components: <AboutUs />, to: '/aboutUs' },
    { components: <ProjectDetails />, to: '/projectDetails' },
    { components: <SMediaService />, to: '/sMediaService' },

   
    {
  components: <Blogs />,
  to: '/blogs'
},
{
  components: <BlogDetails />,
  to: '/blog/:id'
}
];

export default routes;